import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { ActivitiesGrid } from './ActivitiesGrid';
export function ActivitiesPage() {
  return <PageLayout data-id="element-255">
      <HeaderBanner data-id="element-256" />
      <ActivitiesGrid data-id="element-257" />
    </PageLayout>;
}